export default "/fonts/Poppins-Regular.ttf?ccfdd78d095fe3607726da612d40597a";